import React, { FunctionComponent, ReactNode } from "react";
import {
  Button as MUButton,
  ButtonProps,
  makeStyles,
  createStyles,
} from "@material-ui/core";

import CircularProgress from "@material-ui/core/CircularProgress";

import styles from "./Button.module.scss";
import cn from "classnames";

const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      position: "relative",
      width: "fit-content",
    },

    buttonProgress: {
      position: "absolute",
      color: `var(--blue)`,
      top: "50%",
      left: "50%",
      marginTop: -9,
      marginLeft: -12,
    },
  })
);

const Button: FunctionComponent<
  {
    children?: ReactNode;
    disabled?: boolean;
    loading?: boolean;
    buttonVariant?: "primary" | "secondary" | "default";
    textTransform?: "capitalize";
  } & ButtonProps
> = ({
  children,
  disabled,
  loading,
  buttonVariant = "primary",
  textTransform,
  ...props
}) => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      {buttonVariant === "primary" && (
        <MUButton
          variant="contained"
          className={cn(styles.button, {
            [styles.button__disabled]: disabled || loading,
            [styles.button__loading]: loading,
            [styles.button__capitalize]: textTransform === "capitalize",
          })}
          disabled={disabled || loading}
          {...props}
        >
          {children}
        </MUButton>
      )}

      {buttonVariant === "secondary" && (
        <MUButton
          variant="contained"
          className={cn(styles.button, styles.button_secondary, {
            [styles.button_secondary__disabled]: disabled || loading,
            [styles.button__loading]: loading,
            [styles.button__capitalize]: textTransform === "capitalize",
          })}
          disabled={disabled || loading}
          {...props}
        >
          {children}
        </MUButton>
      )}

      {buttonVariant === "default" && (
        <MUButton
          className={cn(styles.button, styles.button_default, {
            [styles.button_default__disabled]: disabled || loading,
            [styles.button__loading]: loading,
            [styles.button__capitalize]: textTransform === "capitalize",
          })}
          disabled={disabled || loading}
          {...props}
        >
          {children}
        </MUButton>
      )}

      {loading && (
        <CircularProgress
          size={18}
          thickness={6}
          className={classes.buttonProgress}
        />
      )}
    </div>
  );
};

export default Button;
